import { parseProductsCategoryPageUrlQueryString } from 'services/products/filters/product-query';
import { GetServerSidePropsContext } from 'next';
import { ProductsCategoryPage } from 'views/ProductListingPage';
import { RestExitError } from 'types/error';
import {
  ProductPageState,
  ProductsCategoryPageProps,
} from 'views/ProductListingPage/utils/products-listing-page-props';
import { getOptionalExperienceFragmentById } from 'services/content/get-experience-fragment-by-id';
import { getProductsByCategory } from 'services/products/get-products-by-category';

                                                                                                   
export interface CategoriesParams {
  categories: string[];
}
export type CategoriesGetServerSidePropsContext = GetServerSidePropsContext & {
  params: CategoriesParams;
};

export async function getServerSideProps(
  context: CategoriesGetServerSidePropsContext,
): Promise<{ props: ProductsCategoryPageProps } | { notFound: true }> {
  try {
    const productQuery = parseProductsCategoryPageUrlQueryString(
      context.query,
      context.params.categories,
    );
    const [searchResults, interrupterResponse] = await Promise.all([
      getProductsByCategory(productQuery),
      getOptionalExperienceFragmentById(`products_listing_page/interrupter`),
    ]);
    const interrupter = interrupterResponse ? interrupterResponse[0] : null;

    const initialState: ProductPageState = {
      productQuery,
      searchResults,
    };

    return {
      props: {
        initialState,
        interrupter,
        ...searchResults,
      },
    };
  } catch (e) {
    if ((e as RestExitError).statusCode === 404) {
      return {
        notFound: true,
      };
    }
    throw e;
  }
}

export default ProductsCategoryPage;
